import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import createReduxPromiseListener from 'redux-promise-listener';
import { persistStore, persistReducer } from 'redux-persist';
import reduxReset from 'redux-reset';
import storage from 'redux-persist/lib/storage';
import rootReducer from './reducers';
import rootSaga from './sagas';
import history from './historyInstance';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'admin',
    'user',
    'allUsers',
    'jobPosts',
    'userCandidates',
    'pendingCandidates',
    'notes',
  ],
};

const sagaMiddleware = createSagaMiddleware();

const reduxPromiseListener = createReduxPromiseListener();

const persistedReducer = persistReducer(persistConfig, rootReducer(history));

const store = createStore(
  persistedReducer,
  composeWithDevTools(
    applyMiddleware(reduxPromiseListener.middleware, sagaMiddleware, routerMiddleware(history)),
    reduxReset()
  )
);

sagaMiddleware.run(rootSaga);

export const promiseListener = reduxPromiseListener;

export const persistor = persistStore(store);

export default store;
